import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { StickyService } from '@app/services/sticky.service';


import { Subscription } from 'rxjs';

/**
 * A component that functions as a sticky footer with actions buttons.
 *
 * The configuration and events for this sticky footer can be accessed from the StickService.
 */
@Component({
    selector: "sticky-button-bar",
    templateUrl: "./sticky-button-bar.component.html",
    styleUrls: ["./sticky-button-bar.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class StickyButtonBarComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'StickyButtonBarComponent';

  private buttonConfigurationChangeSubscription: Subscription;
  private buttonBarVisibilitySubscription: Subscription;
  
  buttonConfiguration: any[];

  public isVisible = false;

  constructor(private stickyService: StickyService) {
    
  }

  ngOnInit() {
    this.buttonConfigurationChangeSubscription = this.stickyService.buttonConfigurationChange.subscribe({
      next: config => {
        this.buttonConfiguration = config;
      },
      error: err => {
        console.error(err);
      }
    });

    this.buttonBarVisibilitySubscription = this.stickyService.buttonBarVisibility.subscribe({
      next: isVisible => {
        this.isVisible = isVisible;
      },
      error: err => {
        console.error(err);
      }
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.

    if (this.buttonConfigurationChangeSubscription) {
      this.buttonConfigurationChangeSubscription.unsubscribe();
    }

    if (this.buttonBarVisibilitySubscription) {
      this.buttonBarVisibilitySubscription.unsubscribe();
    }
  }

  /**
   * Handles a button press
   */
  public onButtonClick(evt: MouseEvent, item: any) {
    console.log(`${this._componentName}.onButtonClick `, evt, item);
    if (item) {
      this.stickyService.buttonPress.next(item.name);
    }
  }
}
